import React from 'react'

const IndustriesCore = ({industries}) => {
  return (
    <div>
        
          <div className='row'>
        {
          industries.map((val,i)=>(
            <div key={i}  className={`col-lg-4 col-md-6   m-auto mb-4 `}>
              <div  className='flutter-three-width p-3  bg-light  shadow rounded-4 text-center h-100   flutter-solution-box'>
                <div className='hover-hidden-content' >

                <img src={val.icon} alt="" className=' icon-50' style={{height:50,width:50}} />
                <h3 className='fs-4 mt-4 h3-heading lh-base'>{val.title}</h3>
                </div>
                <div className='hover-content-part'>
                <p className='fs-6 h3-para lh-base'>{val.desc}</p>
                </div>
              </div>
            </div>
          ))
        }

      </div>
    </div>
  )
}

export default IndustriesCore